import React, { useEffect, useState } from "react";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Sidebar } from "./Sidebar";
import { Header } from "./Header";
import { Footer } from "./Footer";
import Banner from "./components/Banner";
import SliderContainer from "./components/SliderContainer";

const AviatorGames = () => {
  const [isSidebar, setSidebar] = useState(false);
  const AviatorAllGames = [

    {
      src: "https://bindaaswin.com/jdb_images/22001_200x200_en.png",
      name: "Aviator",
      GAMEID:
        "a04d1f3eb8ccec8a4823bdf18e3f0e84",
      provider: "jdb",
    },
    
    {src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Limbo.png",
      name: "Limbo",
      GAMEID:
        "eabf08253165b6bb2646e403de625d1a",
      provider:
        "jili"},
        {
          src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Crash-Bonus.png",
          name: "Crash Bonus",
          GAMEID:
            "a7f3e5f210523a989a7c6b32f2f1ad42",
          provider:
            "jili",
        },
        {
          src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Go-Rush.png",
          name: "Go Rush",
          GAMEID:
            "edef29b5eda8e2eaf721d7315491c51d",
          provider:
            "jili",
        },
        { src: "/Turbo_games/aero.jpg", name: "Aero",GAMEID: 'aero',provider:'turbo'},
        { src: "/Turbo_games/crashx.jpg", name: "Crash X",GAMEID:'crash',provider:'turbo' },
        { src: "/Turbo_games/crash2.jpg", name: "Crash X Football Edition",GAMEID:'crashfootball',provider:'turbo'},

];


  useEffect(() => {
    window.scrollTo(0,0);
    const handleResize = () => {
      if (window.innerWidth > 991) {
        setSidebar(true);
      } else {
        setSidebar(false);
      }
    };

    // Add event listener for resize
    window.addEventListener("resize", handleResize);

    // Initial check to set the correct sidebar state
    handleResize();

    // Cleanup the event listener on component unmount
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <app-root _nghost-jrx-c101="" ng-version="12.2.16">
      <div _ngcontent-jrx-c101="">
        <app-landing-page-new _nghost-jrx-c95="" className="ng-star-inserted">
          <div _ngcontent-jrx-c95="" className="head-container">
            <div _ngcontent-jrx-c95="" className="body-container">
              <Sidebar isSidebar={isSidebar} setSidebar={setSidebar} />
              <div
                _ngcontent-jrx-c95=""
                className={`rightbar`}
                style={{
                  width: isSidebar ? "" : "100%",
                  transition: "width 0.3s ease-in-out",
                }}
              >
                <Header isSidebar={isSidebar} setSidebar={setSidebar} />

                <Banner />

                <div className="mt-5 mb-5 newMain">
                  <p className="d-flex justify-content-between align-items-center main mx-3">
                    <span className="head">Hot Games</span>{" "}
                    {/* <span className="all">See All</span> */}
                  </p>

                  <div className="brdr text-nowrap">
                    <SliderContainer CurrentSlider={AviatorAllGames} />
                  </div>
                </div>

                <Footer />
              </div>
            </div>
          </div>
        </app-landing-page-new>
      </div>
    </app-root>
  );
};

export default AviatorGames;